/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyModel
 */
export interface MoneyModel {
    /**
     * 
     * @type {number}
     * @memberof MoneyModel
     */
    amount: number;
}

/**
 * Check if a given object implements the MoneyModel interface.
 */
export function instanceOfMoneyModel(value: object): value is MoneyModel {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function MoneyModelFromJSON(json: any): MoneyModel {
    return MoneyModelFromJSONTyped(json, false);
}

export function MoneyModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyModel {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
    };
}

export function MoneyModelToJSON(value?: MoneyModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
    };
}

